import { defineComponent as s, openBlock as i, createBlock as l, resolveDynamicComponent as p, unref as n, withCtx as c, renderSlot as a } from "vue";
import { useCollapseContext as d } from "@teamnovu/kit-composables";
const C = /* @__PURE__ */ s({
  __name: "AccordionBody",
  props: {
    is: { default: "section" }
  },
  setup(f) {
    const e = d();
    return (o, m) => {
      var t, r;
      return i(), l(p(o.is), {
        id: (t = n(e)) == null ? void 0 : t.id,
        ref: (r = n(e)) == null ? void 0 : r.ref
      }, {
        default: c(() => [
          a(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["id"]);
    };
  }
});
export {
  C as _
};
